import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="bg-gray-50 min-h-screen py-12 px-4 sm:px-6 lg:px-8 font-sans text-gray-800">
      <div className="max-w-4xl mx-auto bg-white p-8 sm:p-12 rounded-xl shadow-md border border-gray-100">
        
        {/* Header */}
        <div className="border-b-2 border-blue-600 pb-6 mb-8">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight">
            PRIVACY POLICY
          </h1>
          <p className="text-sm text-gray-500 mt-2 italic">
            Sudeesha Solutions — Last Updated: July 02, 2026
          </p>
        </div>

        <p className="mb-6 leading-relaxed text-justify">
          At <strong className="text-slate-900">Sudeesha Solutions</strong> (accessible via <a href="https://sudeesha.com/" className="text-blue-600 hover:underline">https://sudeesha.com/</a>), your privacy and data security are of paramount importance to us. This Privacy Policy outlines how we handle data when you visit our website, inquire about our IT services, or collaborate with us for custom software development.
        </p>

        {/* Section 1 */}
        <section className="mb-8">
          <h2 className="text-xl font-bold text-blue-600 border-l-4 border-blue-600 pl-3 mb-4">
            1. Information We Collect
          </h2>
          <p className="mb-4 leading-relaxed">
            As an IT consulting, software development, and systems integration agency, we collect information under the following categories:
          </p>
          <div className="space-y-4 pl-2">
            <div>
              <h3 className="font-semibold text-slate-900">A. Business & Inquiry Information</h3>
              <p className="text-gray-600 pl-4 mt-1">
                <strong>Contact Details:</strong> Name, email address (sudeesha23@gmail.com), phone number, and company name when you fill out an inquiry form or request a quote.
              </p>
              <p className="text-gray-600 pl-4 mt-1">
                <strong>Project Requirements:</strong> Project briefs, UI/UX designs, features, and technical specifications shared for development.
              </p>
            </div>
            <div>
              <h3 className="font-semibold text-slate-900">B. Client Credentials & Third-Party Integrations</h3>
              <p className="text-gray-600 pl-4 mt-1">
                To build and deploy your custom web or mobile applications, we may temporarily require secure access to your infrastructure, including third-party API keys/configurations for <strong>Payment Gateways (Razorpay, Stripe, PayPal)</strong>, SMS gateways, and server/database access (SQL Server, PostgreSQL, Firebase).
              </p>
            </div>
          </div>
        </section>

        {/* Section 2 */}
        <section className="mb-8">
          <h2 className="text-xl font-bold text-blue-600 border-l-4 border-blue-600 pl-3 mb-4">
            2. Technical Expertise & Data Handling
          </h2>
          <p className="mb-3 leading-relaxed text-justify">
            We build custom solutions using modern technology stacks (.NET, React JS, React Native, Angular, SQL Server, PostgreSQL, Firebase).
          </p>
          <p className="mb-3 leading-relaxed text-justify">
            <strong>Payment Gateway Integration:</strong> When we integrate payment gateways into your apps or websites, we do so using industry-standard secure protocols (SDKs, Webhooks, and HTTPS).
          </p>
          <p className="mb-3 leading-relaxed text-justify">
            <strong>Data Isolation:</strong> Sudeesha Solutions <em>never</em> retains, stores, or monitors the financial data, transaction histories, or personal details of <em>your</em> end-users/customers. All transaction traffic flows directly between your application and the authorized payment gateway providers.
          </p>
        </section>

        {/* Section 3 */}
        <section className="mb-8">
          <h2 className="text-xl font-bold text-blue-600 border-l-4 border-blue-600 pl-3 mb-4">
            3. Code & Credential Security
          </h2>
          <p className="mb-3 leading-relaxed text-justify">
            We treat your proprietary source code, business logic, and API credentials as strictly confidential. All client-provided credentials (such as sandbox or live API keys for payment setups) are restricted only to the developers assigned to your project.
          </p>
          <div className="bg-amber-50 border-l-4 border-amber-500 p-4 my-4 rounded-r-md">
            <p className="text-sm text-amber-800 font-medium">
              <strong>Security Recommendation:</strong> Once a project is successfully deployed and handed over, we strongly advise clients to rotate or change their environment passwords and live API secret keys for maximum security.
            </p>
          </div>
        </section>

        {/* Section 4 */}
        <section className="mb-8">
          <h2 className="text-xl font-bold text-blue-600 border-l-4 border-blue-600 pl-3 mb-4">
            4. Contact Us
          </h2>
          <p className="mb-4">If you have any questions about our development practices, integration safety, or data handling, please reach out to us:</p>
          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 text-sm space-y-1">
            <p><strong className="text-slate-900">Company Name:</strong> Sudeesha Solutions</p>
            <p><strong className="text-slate-900">Website:</strong> <a href="https://sudeesha.com" className="text-blue-600 hover:underline">https://sudeesha.com/</a></p>
            <p><strong className="text-slate-900">Email:</strong> <a href="mailto:sudeesha23@gmail.com" className="text-blue-600 hover:underline">sudeesha23@gmail.com</a></p>
          </div>
        </section>

      </div>
    </div>
  );
};

export default PrivacyPolicy;